export default __webpack_public_path__ + "static/dTadPROI-9b0d3f47ebf9d97b661b161781257e32.svg";